import 'angular:locale/data:en';
import 'angular:locale/data:he';
import 'src/polyfills-legacy';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
